/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:0a24c314-f6c8-4ed6-9283-724f81704d4f",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_5nkOTJjaI",
    "aws_user_pools_web_client_id": "7r7oe29vfv17sek4vaq5tuoq61",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "oshiAPI",
            "endpoint": "https://9c0zul21wi.execute-api.us-east-1.amazonaws.com/uat",
            "region": "us-east-1"
        },
        {
            "name": "daemon",
            "endpoint": "https://g68rotxulh.execute-api.us-east-1.amazonaws.com",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://d7r3m64dlzcmneytugxth3a2tu.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-2m2luhdgdbbavblsh3u7rugxk4",
    "aws_mobile_analytics_app_id": "b27a42f653544437a6708d9c84be5458",
    "aws_mobile_analytics_app_region": "us-east-1",
    "aws_user_files_s3_bucket": "multimedia142006-dev",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "authsession-uat",
            "region": "us-east-1"
        },
        {
            "tableName": "cachedata-uat",
            "region": "us-east-1"
        },
        {
            "tableName": "cacheddata-uat",
            "region": "us-east-1"
        },
        {
            "tableName": "authsessions-uat",
            "region": "us-east-1"
        },
        {
            "tableName": "multimediameta-uat",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "multimedia174543-uat",
    "aws_user_files_s3_bucket_region": "us-east-1"
};
export default awsmobile;
